import { createSlice } from "@reduxjs/toolkit";
function formatDate(inputDate) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options);
}
export const agentProfileSlice = createSlice({
  name: "agentProfile",
  initialState: {
    agentData: {
      firstName: "",
      middleName: "",
      lastName: "",
      suffixName: "",
      agentMobile: "",
      agentEmail: "",
      birthDate: "",
      createdAt: "",
      verifiedOn: "",
      verifiedStatus: "",
      loadBalance: "",
      walletBalance: "",
      agentStatusComments: "",
      partnerId: -1,
      partnerBranchId: -1,
      comments: "",
      rejectedIdPics: null,
      agentStatus: "",
      idPhotoUrl: "",
    },
    uploadAgentIdData: {
      oi: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      pi2: 0,
      pai0: 0,
      fn0: "",
      ln1: "",
      mn: "",
      sn2: "",
      bd: "",
      iti: 0,
      in: "",
      p1: "",
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
    },
    partnerList: [],
    branchList: [],
    idStatusList: [
      "Unverified",
      "Verified",
      "Pending verification",
      "Rejected",
    ],
    agentStatusList: ["Suspended", "Active", "Active with Warning"],
    agentStatusHistory: [],
    verifiedStatusHistory: [],
    dropoffHistory: [],
  },
  reducers: {
    getAgentData: (state, actions) => {
      if (actions.payload) {
        var updateAgentData = { ...actions.payload };
        updateAgentData.partnerId = actions.payload.partner.partnerId;
        updateAgentData.partnerId = actions.payload.partner.partnerId;
        updateAgentData.partnerBranchId =
          actions.payload.partnerBranch.partnerBranchId;
        updateAgentData.agentStatusComments = actions.payload.agentStatusComments
          ? actions.payload.agentStatusComments
          : "";
        updateAgentData.comments = actions.payload.comments ? actions.payload.comments : "";
        state.agentData = updateAgentData;
      }
    },
    getUploadAgentIdData: (state, actions) => {
      state.uploadAgentIdData = actions.payload;
    },
    getPartnerList: (state, actions) => {
      var tempVar = [];
      if (actions.payload.partners)
        actions.payload.partners.forEach((element) => {
          tempVar.push({
            value: element.partnerId,
            name: element.companyNickname,
          });
        });
      state.partnerList = tempVar;
    },
    getBranchList: (state, actions) => {
      var tempVar = [];
      if (actions.payload.partnerBranches)
        actions.payload.partnerBranches.forEach((element) => {
          tempVar.push({
            value: element.partnerBranchId,
            name: element.partnerBranch,
          });
        });
      state.branchList = tempVar;
    },
    getAgentStatusList: (state, actions) => {
      const { type, data } = actions.payload;
      const { agentStatusHistory } = data;
      var tempVar = [];
      if (agentStatusHistory) {
        if (type === "agentStatus") {
          agentStatusHistory.forEach((element) => {
            tempVar.push({
              agentStatus:
                element.agentStatus > -1
                  ? state.agentStatusList[element.agentStatus]
                  : "Blocked",
              agentStatusComments: element.agentStatusComments,
              comments: element.comments,
              createdAt: formatDate(
                element.createdAt.substring(0, element.createdAt.indexOf("T"))
              ),
            });
          });
          state.agentStatusHistory = tempVar;
        } else {
          agentStatusHistory.forEach((element) => {
            tempVar.push({
              verifiedStatus: state.idStatusList[element.verifiedStatus],
              agentStatusComments: element.agentStatusComments,
              comments: element.comments,
              createdAt: formatDate(
                element.createdAt.substring(0, element.createdAt.indexOf("T"))
              ),
            });
          });
          state.verifiedStatusHistory = tempVar;
        }
      }
    },
    getDropoffStatusList: (state, actions) => {
      state.dropoffHistory = actions.payload.packageDropoffStatusHistory;
    },
    handleOnChange: (state, actions) => {
      const { name, value } = actions.payload;
      console.log({ name, value });
      switch (name) {
        case "partner":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              partnerId: value,
            },
          };
        case "branch":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              partnerBranchId: value,
            },
          };
        case "rejectedIdPics":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              rejectedIdPics: [value],
            },
          };
        case "agentStatus":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              agentStatus: value,
            },
          };
        case "agentStatusComments":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              agentStatusComments: value,
            },
          };
        case "comments":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              comments: value,
            },
          };

        case "statusDuration":
          return {
            ...state,
            agentData: {
              ...state.agentData,
              statusDuration: value,
            },
          };
        default:
          break;
      }
    },
    handleUploadAgentIdReducer: (state, actions) => {
      const { name, files } = actions.payload;
      if (files) {
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
          // The result property contains the base64 encoded data
          const base64String = event.target.result;
          console.log(base64String);
        };

        // Read the file as a data URL (base64 encoded)
        reader.readAsDataURL(file);
      } else {
        console.log(name);
      }
    },
  },
});

export const {
  getAgentData,
  getUploadAgentIdData,
  getPartnerList,
  getBranchList,
  getAgentStatusList,
  getDropoffStatusList,
  handleOnChange,
  handleUploadAgentIdReducer,
} = agentProfileSlice.actions;

export default agentProfileSlice.reducer;
